export default "__VITE_ASSET__c9195caa__"